import { User, Mail, Shield } from 'lucide-react';
import Modal from '../../../../components/modals/Modal';
import { useAuth } from '../../../../hooks/useAuth';

export default function ProfileModal({ isOpen, onClose }) {
  const { user } = useAuth();

  const fullName = user?.FullName || user?.name || 'N/A';
  const email = user?.Email || user?.email || 'N/A';
  const role = user?.Position || user?.Roles?.[0]?.RoleName || user?.role || 'N/A';

  const fields = [
    { label: 'Full Name', value: fullName, icon: User },
    { label: 'Email Address', value: email, icon: Mail },
    { label: 'Role', value: role, icon: Shield },
  ];

  return (
    <Modal isOpen={isOpen} onClose={onClose} title="User Profile" icon={User} maxWidth="max-w-md">
      <div className="space-y-5">
        {/* Avatar */}
        <div className="flex flex-col items-center mb-2">
          <div className="w-20 h-20 rounded-full bg-brand-navy flex items-center justify-center text-white text-2xl font-bold shadow-md mb-3">
            {fullName !== 'N/A'
              ? fullName
                  .split(/\s+/)
                  .map((w) => w[0])
                  .join('')
                  .toUpperCase()
              : 'U'}
          </div>
          <p className="text-[17px] font-bold text-brand-navy">{fullName}</p>
          <p className="text-sm text-brand-navy/50 capitalize">{role}</p>
        </div>

        {/* Info fields */}
        <div className="space-y-3">
          {fields.map((field) => (
            <div
              key={field.label}
              className="flex items-center space-x-3 p-3 rounded-lg bg-brand-gray-light border border-brand-gray/40"
            >
              <div className="w-8 h-8 rounded-md bg-brand-navy/10 flex items-center justify-center flex-shrink-0">
                <field.icon className="w-4 h-4 text-brand-navy" />
              </div>
              <div>
                <p className="text-xs text-brand-navy/50 font-medium uppercase tracking-wide">{field.label}</p>
                <p className="text-[15px] font-semibold text-brand-navy">{field.value}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </Modal>
  );
}
